{
  "name": "auth-edutin",
  "version": "3.0.6",
  "scripts": {
    "ng": "ng",
    "start:local": "ng serve --host 127.0.0.1 --port 4200",
    "start:local2": "ng serve --host 127.0.0.1 --port 8100",
    "start:dev": "ng serve --configuration=developer --host 127.0.0.1 --port 4200 -o",
    "start:prod": "ng serve --configuration=production --host 127.0.0.1 --port 4200 -o",
    "start:ssl": "ng serve --configuration=ssl-dev --host dev-app-local.com --port 4200 -o",
    "start:ssl2": "ng serve --configuration=ssl-dev --host 0.0.0.0 --port 4200 -o",
    "build": "ng build --prod --aot",
    "build:dev": "ng build --configuration=developer --aot",
    "build:prod": "ng build --configuration=production --aot",
    "start:proxy": "ng serve --proxy-config proxy.conf.json",
    "watch": "ng build --watch --configuration=development",
    "test": "ng test",
    "/* Scripts de Despliegue - Producción */": "",
    "deploy:prod:win": "cd deployment && python deploy.py --clean-bucket --env production --invalidate-cloudfront",
    "deploy:prod:mac": "cd deployment && python3 deploy.py --clean-bucket --env production --invalidate-cloudfront",
    "/* Scripts de Despliegue - Desarrollo */": "",
    "deploy:dev:win": "cd deployment && python deploy.py --clean-bucket --env development --invalidate-cloudfront",
    "deploy:dev:mac": "cd deployment && python3 deploy.py --clean-bucket --env development --invalidate-cloudfront",
    "/* Scripts de Build && Despliegue */": "",
    "build-deploy:prod:win": "npm run build:prod && npm run deploy:prod:win",
    "build-deploy:prod:mac": "npm run build:prod && npm run deploy:prod:mac",
    "build-deploy:dev:win": "npm run build:dev && npm run deploy:dev:win",
    "build-deploy:dev:mac": "npm run build:dev && npm run deploy:dev:mac"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.0.0",
    "@angular/common": "^19.0.0",
    "@angular/compiler": "^19.0.0",
    "@angular/core": "^19.0.0",
    "@angular/forms": "^19.0.0",
    "@angular/platform-browser": "^19.0.0",
    "@angular/platform-browser-dynamic": "^19.0.0",
    "@angular/router": "^19.0.0",
    "@ngx-translate/core": "^16.0.4",
    "@ngx-translate/http-loader": "^16.0.0",
    "crypto-js": "^4.2.0",
    "jwt-decode": "^4.0.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.0.5",
    "@angular/cli": "^19.0.5",
    "@angular/compiler-cli": "^19.0.0",
    "@types/crypto-js": "^4.2.2",
    "@types/jasmine": "~5.1.0",
    "jasmine-core": "~5.4.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.6.2"
  }
}
